
export function getFileName(fileName) {
    if (fileName == null || fileName == "") {
        return null;
    }
    const index = fileName.lastIndexOf("/");
    const lastIndex = fileName.lastIndexOf(".");
    return fileName.substring(index + 1, lastIndex >= 0 ? lastIndex:fileName.length);
}


export function getUploadFileId(url){
    const fileId = getFileName(url);
    const lastIndexOf = fileId.lastIndexOf("_");
    if(lastIndexOf > 0){
        return fileId.substring(lastIndexOf + 1);
    }
    return fileId;
}